import { useSyncExternalStore } from 'react'
import { repository } from '../data/repository'

export const useAppState = () => useSyncExternalStore(repository.subscribe, repository.getSnapshot)
export const useRepositoryError = () => useSyncExternalStore(repository.subscribe, repository.getError)
